// context/AuthContext.js
"use client"
import { createContext, useContext, useState, useEffect, ReactNode, Dispatch, SetStateAction } from 'react';

const initUserInfo = {
  id: 0,
  username: ''
}
interface AuthContextType {
  userInfo: CustomResponse.UserInfo,
  setUserInfo: Dispatch<SetStateAction<CustomResponse.UserInfo>>,
  initUserInfo: CustomResponse.UserInfo
  // logout: () => void;
}
const AuthContext = createContext<AuthContextType>({
  userInfo: initUserInfo,
  setUserInfo: function () { },
  initUserInfo
});

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [userInfo, setUserInfo] = useState<CustomResponse.UserInfo>(initUserInfo);

  useEffect(() => {
    console.log('context userinfo：', userInfo)
  }, [userInfo])

  return (
    <AuthContext.Provider value={{ userInfo, setUserInfo, initUserInfo }}>
      {children}
    </AuthContext.Provider>
  );
};


export const useAuth = () => useContext(AuthContext);
